import './Filter.css';
import FilterRow from './FilterRow';

function Filter({ gpuArray, loading, selectedGPU, setSelectedGPU }) {
    return (
        <aside className="Filter">
            <div>
                <h2>Select GPU</h2>
                <p className="FilterCopy">
                    {loading ? 'Loading the latest GPU list...' : `Choose from ${gpuArray.length} reported GPUs.`}
                </p>
            </div>
            <div className="FilterList">
                <FilterRow
                    gpuName="Any"
                    isSelected={selectedGPU === 'Any'}
                    onSelect={setSelectedGPU}
                />
                {gpuArray.length > 0 ? (
                    gpuArray.map((gpuName) => (
                        <FilterRow
                            key={gpuName}
                            gpuName={gpuName}
                            isSelected={selectedGPU === gpuName}
                            onSelect={setSelectedGPU}
                        />
                    ))
                ) : (
                    !loading ? <p className="FilterEmptyState">No GPU rows were found in the CSV.</p> : null
                )}
            </div>
        </aside>
    );
}

export default Filter;
